import { AppId } from '../constants';
import { addAppPrefixToUrl } from './addAppPrefixToUrl';

/**
 * Build the URL of a page slug, with the URL prefix of the application that hosts the page.
 * @param app - application that hosts the page.
 * @param slug - page slug, without any application prefix.
 * @param useRawSlug - whether the slug should be used as provided, with no prefix added.
 * @returns the URL of the page.
 */
export const getUrlWithPrefix = (app: AppId, slug: string, useRawSlug: boolean): string => {
    if (!useRawSlug) {
        return addAppPrefixToUrl(slug, app);
    }
    return `/${slug}`;
};
